import service from '@/plugins/request';

// 删除举报
export function apiReportDel (params) {
  return service({
    url: '/v1/protected/report/delete',
    method: 'post',
    data: params,
    successToast: true
  });
}

// 举报列表
export function apiReportList (params) {
  return service({
    url: '/v1/protected/report/list',
    method: 'get',
    params: params
  });
}

// 创建举报
export function apiReport (params) {
  return service({
    url: '/v1/report/create',
    method: 'post',
    data: params,
    successToast: true
  });
}
